import { msg } from 'gt-react';
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// prettier-ignore
// fallow-ignore-next-line circular-dependency
import { Route as pathlessAuthenticatedRoute, requireAdmin, requireModules } from '../../route';

const HistoricalImportPage = lazyRouteComponent(
  () => import('./HistoricalImportPage'),
  'HistoricalImportPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/admin/historical-import',
  staticData: {
    app: {
      nav: {
        label: msg('Historical Data Import', {
          context: 'sidebar nav label, Rebates section',
        }),
        icon: <ClockCounterClockwiseIcon className="h-4 w-4" weight="fill" />,
        group: 'Rebates',
        order: 90,
      },
      access: {
        adminOnly: true,
        modulesAnyOf: [ProductModule.REBATES],
      },
    },
  },
  component: HistoricalImportPage,
  loader: () => ({
    crumb: msg('Historical Import', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireAdmin({ context });
    requireModules({
      context,
      oneOf: [ProductModule.REBATES],
    });
  },
});
